import { FLOW_BY_VERSION_ID_FIELD_NAME, GET_FLOW_BY_VERSION_ID } from 'automation-ui-canvas/containers/enrollment-history/utils/flowByRevisionQueries';
import Flow from 'automation-ui-canvas/flow/records/Flow/Flow';
import { useQuery } from 'data-fetching-client';
import { jsx as _jsx } from "react/jsx-runtime";
export const wireFlowByVersion = WrappedComponent => props => {
  var _flow$createMetadata;
  const {
    flowId,
    versionId
  } = props;
  if (!versionId) {
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      flow: null,
      isFlowLoading: false
    }));
  }
  const {
    data: {
      [FLOW_BY_VERSION_ID_FIELD_NAME]: {
        flow = null
      } = {}
    } = {},
    loading: isFlowLoading,
    error: flowError
  } = useQuery(GET_FLOW_BY_VERSION_ID, {
    variables: {
      flowId,
      versionId
    },
    fetchPolicy: 'network-only'
  });
  const flowObjectTypeId = flow === null || flow === void 0 ? void 0 : flow.objectTypeId;
  const flowSourceApp = flow === null || flow === void 0 || (_flow$createMetadata = flow.createMetadata) === null || _flow$createMetadata === void 0 ? void 0 : _flow$createMetadata.sourceApp;
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    flow: flow ? new Flow(flow) : null,
    flowError: flowError,
    isFlowLoading: isFlowLoading,
    flowObjectTypeId: flowObjectTypeId // for queryAllExtensionDefinitions
    ,
    flowSourceApp: flowSourceApp // for queryAllExtensionDefinitions
  }));
};